import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Image } from '@components/ui';
import { useMediaQuery } from '@hooks/useMediaQuery';

import ProductPrice from '../ProductPrice/ProductPrice';

import ProductOnboardingCardActions from './ProductOnboardingCardActions';

import styles from './ProductOnboardingCard.module.scss';

const ProductOnboardingCard = (props) => {

  const {
    className,
    disabled,
    order = {},
    product = {},
    listProps = {},
  } = props;

  // Hooks

  const isBreakpoint = useMediaQuery(`(max-width: ${styles.breakpointMd})`);
  const isSmallBreakpoint = useMediaQuery(`(max-width: ${styles.breakpointXsm})`);

  // Props

  const {
    image,
    name,
    brand,
    //
    currency,
    originalPrice,
    price,
    taxes,
  } = product;

  // Render

  return (
    <div className={classnames(styles.root, className)}>

      {/* Image Container */}
      <div className={styles.imageContainer}>

        {/* Image */}
        <Image
          className={styles.image}
          src={image?.thumbnail}
          width={400}
          height={400}
          square
          alt={name}
        />

        {/* Actions */}
        <ProductOnboardingCardActions
          className={styles.actions}
          order={order}
          product={product}
          listProps={listProps}
          disabled={disabled}
        />
      </div>

      {/* Details */}
      <div className={styles.details}>

        {/* Brand */}
        <div className={styles.brand}>{brand}</div>

        {/* Name */}
        <div className={styles.name}>{name}</div>

        {/* Price */}
        <ProductPrice
          className={styles.productPrice}
          mainClassName={styles.productPriceMain}
          priceWrapperClassName={styles.priceWrapper}
          originalPriceClassName={styles.originalPrice}
          priceClassName={styles.price}
          taxesClassName={styles.taxes}
          //
          currency={currency}
          originalPrice={originalPrice}
          price={price}
          taxes={taxes}
        />

      </div>

    </div>
  );

};

ProductOnboardingCard.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  order: PropTypes.shape({}),
  product: PropTypes.shape({}),
  listProps: PropTypes.shape({
    analyticsListId: PropTypes.string,
    analyticsListName: PropTypes.string,
  }),
};

export default ProductOnboardingCard;
